module.exports = __webpack_public_path__ + "img/fi-oppilaitos.82cb3fbf.png";